import React, { useRef } from 'react'
import { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "react-loader-spinner";
import { useReactToPrint } from 'react-to-print';
import Swal from "sweetalert2";
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { DecryptED } from "../../DecryptJS/Decrypt";

const AdminLessonReport = () => {
  const { sid, id, userid } = useParams();
  const [reports, setReports] = useState({});
  const [apiloader, setapiLoader] = useState(true);

  const tableRef = useRef(null);
  const generatePdf = useReactToPrint({
    content: () => tableRef.current,
    documentTitle: "LessonReport",
    onAfterPrint: () =>
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Print Success!",
        showConfirmButton: false,
        timer: 1500,
      }),
  })

  function formatDate(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  const getReportById = async () => {
    setapiLoader(true);
    try {
      const data = {
        "sid": DecryptED(sid),
        "id": DecryptED(id),
        "userId": DecryptED(userid)
      }
      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_URL}/api/admin/lessonPlan/reportById`,
        data,
        headers: {
          Authorization: "#$laksdfnlknoea#$@$%^&%$",
        },
      });
      setReports(response.data[0] || {});
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: (error.response && error.response.data && error.response.data.message) || "Could not load the lesson report",
        showConfirmButton: false,
        timer: 5000,
      });
    } finally {
      setapiLoader(false);
    }
  }
  useEffect(() => {
    getReportById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid, id, userid])

  return (
    <div className='container-fluid' style={{ backgroundColor: '#f4f6fb', minHeight: '100vh', padding: '24px' }}>
      {apiloader ? (
        <div className="TMLoader">
          <Loader type="ThreeDots" color="#bd2f5e" height={80} width={80} />
        </div>
      ) :

        <div className='container card shadow-sm rounded p-4 bg-white'>
          <Link
            to={`/admin/lessonPlan/${sid}/${userid}`}
            aria-label="Back to lesson plan reports"
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "fit-content",
              gap: "6px",
              color: "#1565c0",
              fontWeight: 600,
              textDecoration: "none",
              textAlign: "left",
              marginBottom: "16px",
              marginRight: "auto",
            }}
          >
            <AiOutlineArrowLeft size={20} />
            Back
          </Link>
          <div className='row'>
            <div className='col-md-6 my-2'><b className='text-primary'>Date:{" "}</b>{reports.created_date ? formatDate(reports.created_date) : ""}</div>
            <div className='col-md-6 my-2'><b className='text-primary'>Subject:{" "}</b>{reports.subject ? reports.subject : ""}</div>
            <div className='col-md-6 my-2'><b className='text-primary'>Class/Division: </b>{reports.div_name ? reports.div_name : ""}</div>
            <div className='col-md-6 my-2'><b className='text-primary'>Teacher:{" "}</b>{reports.Teacher ? reports.Teacher : ""}</div>
          </div>

          <hr />

          <div className='my-3'><b className='text-primary'>Lesson Name:{" "}</b>{reports.Lessonname ? reports.Lessonname : ""}</div>
          <hr />
          <button type="button" className='btn btn-primary mt-0 mb-2' onClick={() => { generatePdf(); }}>Export to PDF</button>
          <table className="table table-hover table-bordered" ref={tableRef}>
            <tbody>
              <tr>
                <td><b className='text-primary'>Learning Objectives: </b></td>
                <td>{reports.lesson_objective ? reports.lesson_objective : ""}</td>
                <td><b className='text-primary'>Learning Outcome: </b></td>
                <td>{reports.learning_outcome ? reports.learning_outcome : ""}</td>
              </tr>

              <tr>
                <td><b className='text-primary'>Audio / Visual Aids: </b></td>
                <td>{reports.audio_visual_adis ? reports.audio_visual_adis : ""}</td>
                <td><b className='text-primary'>Pedagogical Practices: </b></td>
                <td>{reports.pedagogical_practices ? reports.pedagogical_practices : ""}</td>
              </tr>

              <tr>
                <td><b className='text-primary'>Teacher Preparation: </b></td>
                <td>{reports.teacher_preparation ? reports.teacher_preparation : ""}</td>
                <td><b className='text-primary'>Student Preparation: </b></td>
                <td>{reports.student_preparation ? reports.student_preparation : ""}</td>
              </tr>

              <tr>
                <td><b className='text-primary'>Additional Extended Information: </b></td>
                <td>{reports.additional_extended_information ? reports.additional_extended_information : ""}</td>
                <td><b className='text-primary'>Interdisciplinary Linkage: </b></td>
                <td>{reports.interdisciplinary_linkage ? reports.interdisciplinary_linkage : ""}</td>
              </tr>

              <tr>
                <td><b className='text-primary'>Infusion With Life Skills: </b></td>
                <td>{reports.infusion_with_life_skills ? reports.infusion_with_life_skills : ""}</td>
                <td><b className='text-primary'>Art Integration: </b></td>
                <td>{reports.art_integration ? reports.art_integration : ""}</td>
              </tr>

              <tr>
                <td><b className='text-primary'>Story Based: </b></td>
                <td>{reports.story_based ? reports.story_based : ""}</td>
                <td><b className='text-primary'>Artificial Intelligence: </b></td>
                <td>{reports.artificial_intelligence ? reports.artificial_intelligence : ""}</td>
              </tr>

              <tr>
                <td><b className='text-primary'>fln: </b></td>
                <td>{reports.fln ? reports.fln : ""}</td>
                <td><b className='text-primary'>Remedial Plan: </b></td>
                <td>{reports.remedial_plan ? reports.remedial_plan : ""}</td>
              </tr>

              <tr>
                <td><b className='text-primary'>Cwsn Plan: </b></td>
                <td>{reports.cwsn_plan ? reports.cwsn_plan : ""}</td>
                <td><b className='text-primary'>Assignment: </b></td>
                <td>{reports.assignment ? reports.assignment : ""}</td>
              </tr>

              <tr>
                <td><b className='text-primary'>Reference Used: </b></td>
                <td>{reports.reference_used ? reports.reference_used : ""}</td>
              </tr>
            </tbody>
          </table>

          <div className="btn-div my-3">
            <Link
              to={`/admin/updatereport/${sid}/${userid}/${id}`}
              style={{
                display: "inline-block",
                height: "40px",
                lineHeight: "40px",
                color: "white",
                backgroundColor: "#1565c0",
                border: "none",
                outline: "none",
                fontSize: "18px",
                padding: "0px 16px",
                borderRadius: "6px",
                cursor: "pointer",
                textDecoration: "none",
                boxShadow: "0 4px 10px rgba(21,101,192,0.25)",
              }}
            >
              EDIT INFORMATION
            </Link>
          </div>
        </div>

      }
    </div>
  )
}

export default AdminLessonReport
